export default "__VITE_ASSET__BVwqN8PF__"